//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import seguroEmpateMixin from '~/mixins/seguro-empate'

export default {
  name: 'ElementsSeguroEmpateActivated',
  mixins: [seguroEmpateMixin],
  props: {
    ticket: { default: null }
  },
  computed: {
    campaign() {
      return this.seguroEmpateCampaignForBet(_.get(this.ticket, 'uuid'))
    },
    conditionSegments() {
      return this.seguroEmpateConditionSegmentsForCampaign(this.campaign)
    }
  }
}
